import React, { useState, useEffect, useRef } from 'react';
import api from '../../api';
import { imgUrl, heroImgUrl, catImgUrl } from '../../utils';
import './Admin.css';

export function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => api.get('/admin/messages').then(r => { setMessages(r.data); setLoading(false); }).catch(()=>setLoading(false));
  useEffect(() => { load(); }, []);
  const markRead = async (id) => { await api.patch(`/admin/messages/${id}/read`); load(); };
  return (
    <div className="admin-page">
      <div className="admin-page-header"><h1 className="admin-page-title">Messages</h1></div>
      {loading ? <div className="page-loading"><div className="spinner"/></div> : (
        <div style={{display:'flex',flexDirection:'column',gap:'12px'}}>
          {messages.map(m => (
            <div key={m._id} style={{background:'var(--white)',border:`1px solid ${m.read_status?'var(--gray-light)':'var(--terracotta)'}`,padding:'24px',opacity:m.read_status?0.7:1}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'12px'}}>
                <div>
                  <strong style={{fontSize:'16px'}}>{m.name}</strong>
                  <span style={{fontSize:'12px',color:'var(--gray)',marginLeft:'12px'}}>{m.email}</span>
                  {m.phone && <span style={{fontSize:'12px',color:'var(--gray)',marginLeft:'8px'}}>{m.phone}</span>}
                </div>
                <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
                  <span style={{fontSize:'12px',color:'var(--gray)'}}>{new Date(m.createdAt).toLocaleDateString('en-GB')}</span>
                  {!m.read_status && <button className="admin-btn admin-btn-approve" onClick={()=>markRead(m._id)}>Mark Read</button>}
                </div>
              </div>
              <p style={{fontSize:'14px',color:'var(--charcoal-mid)',lineHeight:'1.7'}}>{m.message}</p>
            </div>
          ))}
          {messages.length===0 && <div style={{textAlign:'center',padding:'48px',color:'var(--gray)',background:'var(--white)',border:'1px solid var(--gray-light)'}}>No messages yet.</div>}
        </div>
      )}
    </div>
  );
}

export function AdminCategories() {
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({ name:'', parent_id:'', sort_order:0 });
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');
  const [imgMsg, setImgMsg] = useState('');
  // eslint-disable-next-line no-unused-vars
  const fileRefs = useRef({});

  const load = () => api.get('/categories').then(r=>{ setCategories(r.data); setLoading(false); }).catch(()=>setLoading(false));
  useEffect(()=>{load();}, []);

  const add = async (e) => {
    e.preventDefault();
    try { await api.post('/admin/categories', form); setForm({name:'',parent_id:'',sort_order:0}); setMsg('Category added!'); load(); setTimeout(()=>setMsg(''),2000); }
    catch(err) { setMsg(err.response?.data?.error||'Error'); }
  };

  const del = async (id) => {
    if(window.confirm('Delete this category?')) {
      try { await api.delete(`/admin/categories/${id}`); load(); }
      catch(err){ alert(err.response?.data?.error||'Error'); }
    }
  };

  const uploadCatImage = async (catId, file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append('image', file);
    try {
      await api.post(`/admin/categories/${catId}/image`, fd, { headers:{'Content-Type':'multipart/form-data'} });
      setImgMsg('Image saved!');
      load();
      setTimeout(()=>setImgMsg(''),2500);
    } catch(e) { setImgMsg('Error uploading image'); }
  };

  const removeCatImage = async (catId) => {
    try {
      await api.delete(`/admin/categories/${catId}/image`);
      load();
    } catch(e) { alert('Error removing image'); }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header"><h1 className="admin-page-title">Categories</h1></div>
      {imgMsg && <div className="alert alert-success" style={{marginBottom:'16px'}}>{imgMsg}</div>}
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'32px',alignItems:'start'}}>
        <div>
          <h3 style={{fontSize:'20px',marginBottom:'20px'}}>Add Category</h3>
          {msg && <div className="alert alert-success">{msg}</div>}
          <form onSubmit={add} style={{background:'var(--white)',border:'1px solid var(--gray-light)',padding:'28px',display:'flex',flexDirection:'column',gap:'16px'}}>
            <div className="form-group" style={{marginBottom:0}}><label>Category Name *</label><input required value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="e.g. Cardigans" /></div>
            <div className="form-group" style={{marginBottom:0}}>
              <label>Parent Category (leave empty for top-level)</label>
              <select value={form.parent_id} onChange={e=>setForm({...form,parent_id:e.target.value})}>
                <option value="">— Top Level (Women / Men / Children) —</option>
                {categories.map(c=><option key={c._id} value={c._id}>{c.name}</option>)}
              </select>
            </div>
            <div className="form-group" style={{marginBottom:0}}><label>Sort Order</label><input type="number" value={form.sort_order} onChange={e=>setForm({...form,sort_order:parseInt(e.target.value)||0})} /></div>
            <button type="submit" className="admin-btn admin-btn-primary" style={{padding:'12px'}}>Add Category</button>
          </form>
        </div>
        <div>
          <h3 style={{fontSize:'20px',marginBottom:'20px'}}>All Categories</h3>
          {loading ? <div className="spinner"/> : (
            <div style={{background:'var(--white)',border:'1px solid var(--gray-light)'}}>
              {categories.map(parent => (
                <div key={parent._id}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',background:'var(--cream-dark)',borderBottom:'1px solid var(--gray-light)'}}>
                    <div style={{display:'flex',alignItems:'center',gap:'12px',flex:1}}>
                      {parent.image
                        ? <img src={catImgUrl(parent.image)} alt={parent.name} style={{width:'40px',height:'40px',objectFit:'cover',border:'1px solid var(--gray-light)'}} />
                        : <div style={{width:'40px',height:'40px',background:'var(--cream-darker)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',color:'var(--gray)',border:'1px solid var(--gray-light)',flexShrink:0}}>{parent.name[0]}</div>
                      }
                      <strong style={{fontSize:'14px'}}>{parent.name}</strong>
                    </div>
                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                      <label style={{fontSize:'11px',cursor:'pointer',background:'var(--cream)',border:'1px solid var(--gray-light)',padding:'4px 8px',color:'var(--charcoal-mid)',textTransform:'none',letterSpacing:0}}>
                        {parent.image ? 'Change' : 'Set Image'}
                        <input type="file" accept="image/*" style={{display:'none'}} ref={el=>fileRefs.current[parent._id]=el} onChange={e=>{ if(e.target.files[0]) uploadCatImage(parent._id, e.target.files[0]); e.target.value=''; }} />
                      </label>
                      {parent.image && <button className="admin-btn admin-btn-delete" onClick={()=>removeCatImage(parent._id)} title="Remove image">✕</button>}
                      <button className="admin-btn admin-btn-delete" onClick={()=>del(parent._id)}>Delete</button>
                    </div>
                  </div>
                  {parent.subcategories?.map(sub=>(
                    <div key={sub._id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 16px 10px 32px',borderBottom:'1px solid var(--gray-light)'}}>
                      <div style={{display:'flex',alignItems:'center',gap:'10px',flex:1}}>
                        {sub.image
                          ? <img src={catImgUrl(sub.image)} alt={sub.name} style={{width:'32px',height:'32px',objectFit:'cover',border:'1px solid var(--gray-light)'}} />
                          : <div style={{width:'32px',height:'32px',background:'var(--cream)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'11px',color:'var(--gray)',border:'1px solid var(--gray-light)',flexShrink:0}}>{sub.name[0]}</div>
                        }
                        <span style={{fontSize:'13px',color:'var(--charcoal-mid)'}}>{sub.name}</span>
                      </div>
                      <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                        <label style={{fontSize:'11px',cursor:'pointer',background:'var(--cream)',border:'1px solid var(--gray-light)',padding:'3px 6px',color:'var(--charcoal-mid)',textTransform:'none',letterSpacing:0}}>
                          {sub.image ? 'Change' : 'Set Image'}
                          <input type="file" accept="image/*" style={{display:'none'}} onChange={e=>{ if(e.target.files[0]) uploadCatImage(sub._id, e.target.files[0]); e.target.value=''; }} />
                        </label>
                        {sub.image && <button className="admin-btn admin-btn-delete" onClick={()=>removeCatImage(sub._id)} title="Remove image">✕</button>}
                        <button className="admin-btn admin-btn-delete" onClick={()=>del(sub._id)}>Delete</button>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function HeroSlot({ slot, settings, products, onSaved }) {
  const [mode, setMode] = useState('product');
  const [selectedProductId, setSelectedProductId] = useState('');
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const uploadKey = `hero_upload_image_${slot}`;
  const productKey = `hero_product_${slot}`;
  const currentUpload = settings[uploadKey];
  const currentProductId = settings[productKey];

  const save = async () => {
    setSaving(true);
    setMsg('');
    try {
      if (mode === 'product' && selectedProductId) {
        await api.post('/admin/settings', { [productKey]: selectedProductId, [uploadKey]: '' });
        setMsg('Saved!');
        onSaved();
      } else if (mode === 'upload' && file) {
        const fd = new FormData();
        fd.append('image', file);
        await api.post(`/admin/hero-image/${slot}`, fd, { headers:{'Content-Type':'multipart/form-data'} });
        await api.post('/admin/settings', { [productKey]: '' });
        setMsg('Saved!');
        onSaved();
      } else {
        setMsg('Select a product or choose a file first.');
      }
    } catch(e) { setMsg(e.response?.data?.error || 'Error saving'); }
    setSaving(false);
    setTimeout(()=>setMsg(''),3000);
  };

  const clear = async () => {
    await api.post('/admin/settings', { [productKey]: '', [uploadKey]: '' });
    onSaved();
  };

  const currentProduct = products.find(p => p._id === currentProductId);

  return (
    <div style={{background:'var(--white)',border:'1px solid var(--gray-light)',padding:'24px'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'16px'}}>
        <h4 style={{fontSize:'15px',margin:0}}>Hero Image {slot}</h4>
        {(currentUpload || currentProductId) && (
          <button className="admin-btn admin-btn-delete" onClick={clear} style={{fontSize:'11px'}}>Clear</button>
        )}
      </div>

      {/* Current preview */}
      <div style={{marginBottom:'16px',height:'100px',background:'var(--cream-dark)',display:'flex',alignItems:'center',justifyContent:'center',overflow:'hidden'}}>
        {currentUpload
          ? <img src={heroImgUrl(currentUpload)} alt="" style={{height:'100%',width:'100%',objectFit:'cover'}} />
          : currentProduct?.primary_image
          ? <img src={imgUrl(currentProduct.primary_image)} alt="" style={{height:'100%',width:'100%',objectFit:'cover'}} />
          : <span style={{fontSize:'12px',color:'var(--gray)'}}>No image set — showing featured product</span>
        }
      </div>
      {currentProduct && !currentUpload && (
        <p style={{fontSize:'11px',color:'var(--gray)',marginBottom:'12px'}}>Current: {currentProduct.name}</p>
      )}

      {/* Mode toggle */}
      <div style={{display:'flex',gap:'0',marginBottom:'12px',border:'1px solid var(--gray-light)'}}>
        <button
          type="button"
          onClick={()=>setMode('product')}
          style={{flex:1,padding:'7px',fontSize:'12px',border:'none',cursor:'pointer',background:mode==='product'?'var(--terracotta)':'var(--cream)',color:mode==='product'?'white':'var(--charcoal-mid)',fontFamily:'var(--font-sans)'}}
        >Choose Product</button>
        <button
          type="button"
          onClick={()=>setMode('upload')}
          style={{flex:1,padding:'7px',fontSize:'12px',border:'none',cursor:'pointer',background:mode==='upload'?'var(--terracotta)':'var(--cream)',color:mode==='upload'?'white':'var(--charcoal-mid)',fontFamily:'var(--font-sans)'}}
        >Upload Image</button>
      </div>

      {mode === 'product' ? (
        <select value={selectedProductId} onChange={e=>setSelectedProductId(e.target.value)} style={{width:'100%',marginBottom:'10px'}}>
          <option value="">— Select a product —</option>
          {products.map(p => (
            <option key={p._id} value={p._id}>
              {p.parent_name ? `${p.parent_name} › ` : ''}{p.category_name ? `${p.category_name} › ` : ''}{p.name}
            </option>
          ))}
        </select>
      ) : (
        <input
          type="file"
          accept="image/*"
          style={{width:'100%',marginBottom:'10px',fontSize:'12px'}}
          onChange={e=>setFile(e.target.files[0]||null)}
        />
      )}

      {msg && <p style={{fontSize:'12px',color:msg==='Saved!'?'var(--success)':'var(--error)',marginBottom:'8px'}}>{msg}</p>}

      <button
        type="button"
        className="admin-btn admin-btn-primary"
        onClick={save}
        disabled={saving}
        style={{width:'100%',padding:'9px'}}
      >{saving ? 'Saving…' : 'Set This Slot'}</button>
    </div>
  );
}

export function AdminSettings() {
  const [settings, setSettings] = useState({});
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');
  const [pwForm, setPwForm] = useState({ current: '', newPw: '', confirm: '' });
  const [pwMsg, setPwMsg] = useState('');
  const [pwSaving, setPwSaving] = useState(false);

  const loadSettings = () => api.get('/admin/settings').then(r=>setSettings(r.data)).catch(()=>{});
  useEffect(()=>{
    Promise.all([
      api.get('/admin/settings'),
      api.get('/admin/products'),
    ]).then(([s, p]) => {
      setSettings(s.data);
      setAllProducts(p.data);
      setLoading(false);
    }).catch(()=>setLoading(false));
  },[]);

  const save = async (e) => {
    e.preventDefault();
    try { await api.post('/admin/settings', settings); setMsg('Settings saved!'); setTimeout(()=>setMsg(''),3000); }
    catch { setMsg('Error saving settings.'); }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    setPwMsg('');
    if (pwForm.newPw !== pwForm.confirm) return setPwMsg('New passwords do not match');
    if (pwForm.newPw.length < 8) return setPwMsg('Password must be at least 8 characters');
    setPwSaving(true);
    try {
      await api.post('/admin/change-password', { current_password: pwForm.current, new_password: pwForm.newPw });
      setPwMsg('✓ Password changed successfully');
      setPwForm({ current: '', newPw: '', confirm: '' });
    } catch(err) { setPwMsg(err.response?.data?.error || 'Error changing password'); }
    setPwSaving(false);
  };

  const set = (k,v) => setSettings(s=>({...s,[k]:v}));
  if (loading) return <div className="page-loading"><div className="spinner"/></div>;
  return (
    <div className="admin-page">
      <div className="admin-page-header"><h1 className="admin-page-title">Site Settings</h1></div>
      {msg && <div className="alert alert-success">{msg}</div>}
      <form onSubmit={save} style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'32px',alignItems:'start',marginBottom:'40px'}}>
        <div style={{background:'var(--white)',border:'1px solid var(--gray-light)',padding:'32px',display:'flex',flexDirection:'column',gap:'0'}}>
          <h3 style={{fontSize:'18px',marginBottom:'24px'}}>Contact Details</h3>
          <div className="form-group"><label>Contact Email</label><input value={settings.contact_email||''} onChange={e=>set('contact_email',e.target.value)} /></div>
          <div className="form-group"><label>Contact Phone</label><input value={settings.contact_phone||''} onChange={e=>set('contact_phone',e.target.value)} /></div>
        </div>
        <div style={{background:'var(--white)',border:'1px solid var(--gray-light)',padding:'32px',display:'flex',flexDirection:'column',gap:'0'}}>
          <h3 style={{fontSize:'18px',marginBottom:'24px'}}>Landing Page Content</h3>
          <div className="form-group"><label>Hero Tag</label><input value={settings.hero_tag||''} onChange={e=>set('hero_tag',e.target.value)} placeholder="e.g. Wholesale Collection 2026" /></div>
          <div className="form-group"><label>Hero Title</label><input value={settings.hero_title||''} onChange={e=>set('hero_title',e.target.value)} /></div>
          <div className="form-group"><label>Hero Subtitle</label><textarea rows={3} value={settings.hero_subtitle||''} onChange={e=>set('hero_subtitle',e.target.value)} /></div>
          <div className="form-group"><label>About Text</label><textarea rows={4} value={settings.about_text||''} onChange={e=>set('about_text',e.target.value)} /></div>
        </div>
        <div style={{gridColumn:'1/-1'}}>
          <button type="submit" className="btn-terracotta" style={{padding:'14px 40px'}}>Save All Settings</button>
        </div>
      </form>

      {/* HERO IMAGES */}
      <div style={{marginBottom:'40px'}}>
        <h2 style={{fontSize:'22px',marginBottom:'8px'}}>Hero Images</h2>
        <p style={{fontSize:'13px',color:'var(--gray)',marginBottom:'20px'}}>Choose which images appear in the three homepage hero slots. Pick an existing product or upload a direct image for each slot.</p>
        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'20px'}}>
          {[1,2,3].map(slot => (
            <HeroSlot key={slot} slot={slot} settings={settings} products={allProducts} onSaved={loadSettings} />
          ))}
        </div>
      </div>

      {/* ADMIN PASSWORD */}
      <div style={{background:'var(--white)',border:'1px solid var(--gray-light)',padding:'32px',maxWidth:'480px'}}>
        <h3 style={{fontSize:'18px',marginBottom:'20px'}}>Change Admin Password</h3>
        {pwMsg && <div className={`alert ${pwMsg.startsWith('✓') ? 'alert-success' : 'alert-error'}`}>{pwMsg}</div>}
        <form onSubmit={changePassword} style={{display:'flex',flexDirection:'column',gap:'0'}}>
          <div className="form-group"><label>Current Password</label><input required type="password" value={pwForm.current} onChange={e=>setPwForm({...pwForm,current:e.target.value})} /></div>
          <div className="form-group"><label>New Password</label><input required type="password" value={pwForm.newPw} onChange={e=>setPwForm({...pwForm,newPw:e.target.value})} placeholder="Min. 8 characters" /></div>
          <div className="form-group"><label>Confirm New Password</label><input required type="password" value={pwForm.confirm} onChange={e=>setPwForm({...pwForm,confirm:e.target.value})} /></div>
          <button type="submit" className="admin-btn admin-btn-primary" style={{padding:'12px'}} disabled={pwSaving}>
            {pwSaving ? 'Changing...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
